import { useQuery } from "@apollo/client/react";
import { NoPublished, ToEditorVersion } from "../../../components";
import { QueryResult } from "../../../components/common/QueryResult";

import { Changelist, PublishedChangelistDocument } from "../../../graphql/types";

const PublishedBrowser = () => {
  const { loading, error, data } = useQuery(PublishedChangelistDocument, {
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-and-network",
  });
  return (
    <QueryResult
      loading={loading}
      error={error}
      data={data}
      nodeName="changelist"
      emptyElement={<NoPublished />}
      errorElement={<div>There was a problem navigating to the Published version.</div>}
      resultsMapper={(results: Changelist) => <ToEditorVersion versionId={results.id} />}
    />
  );
};

export { PublishedBrowser };
